import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "../components/AppSidebar";
import { AppHeader } from "../components/AppHeader";
import { ScrollToTopButton } from "../components/ScrollToTopButton";
import { SidebarProvider, useSidebarState } from "../hooks/useSidebarState";
import { Sheet, SheetContent } from "../components/ui/sheet";

const ManagementLayoutInner = ({ title, subtitle }) => {
  const { mobileOpen, setMobileOpen } = useSidebarState();
  // Clicking the already-active sidebar item dispatches this event (see AppSidebar). Most
  // pages don't wire up useRouteRefresh individually, so remounting the routed page here
  // guarantees "click current nav item -> refetch its data" works everywhere, not just on
  // the handful of pages that opted in.
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    const handler = () => setRefreshKey((k) => k + 1);
    window.addEventListener("yoko:refresh-route", handler);
    return () => window.removeEventListener("yoko:refresh-route", handler);
  }, []);

  return (
    <div className="flex min-h-screen bg-[#F8FAFC]" data-testid="management-layout">
      <AppSidebar className="no-print hidden md:flex" />

      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-72 sm:max-w-xs" data-testid="mobile-sidebar-drawer">
          <AppSidebar mobile onNavigate={() => setMobileOpen(false)} className="w-full" />
        </SheetContent>
      </Sheet>

      <div className="flex-1 flex flex-col min-w-0">
        <AppHeader title={title} subtitle={subtitle} className="no-print" onOpenMobileNav={() => setMobileOpen(true)} />
        <main className="flex-1 p-4 md:p-8">
          <Outlet key={refreshKey} />
        </main>
      </div>
      <ScrollToTopButton />
    </div>
  );
};

export const ManagementLayout = ({ title, subtitle }) => (
  <SidebarProvider>
    <ManagementLayoutInner title={title} subtitle={subtitle} />
  </SidebarProvider>
);
